import React from "react";
import { Helmet } from "react-helmet-async";
import site from "../../../config/site";

export default function Contact() {
  return (
    <div className="page">
      <Helmet>
        <title>photoLevs: Contact</title>
        <meta
          name="description"
          content="Contact Joseph Levermore (photoLevs) via email, LinkedIn, or Instagram."
        />
        <meta property="og:title" content="photoLevs: Contact" />
      </Helmet>

      <h1 className="page-title">Contact</h1>

      <p className="prose" style={{ marginBottom: 28 }}>
        For business enquiries, please allow 1–2 business days for a response.
      </p>

      <div className="contact-rows">
        <div className="contact-row">
          <span className="label">Email</span>
          <a href={`mailto:${site.email}`}>{site.email}</a>
        </div>

        <div className="contact-row">
          <span className="label">LinkedIn</span>
          <a href={site.linkedin} target="_blank" rel="noopener noreferrer">
            Joseph Michael Levermore
          </a>
        </div>

        <div className="contact-row">
          <span className="label">Instagram</span>
          <a href={site.instagram} target="_blank" rel="noopener noreferrer">
            @photolevs
          </a>
        </div>
      </div>
    </div>
  );
}